[{
    "display": "true",
    "ui_columnname": "Sample Name",
    "db_columnname": "sampleName",
    "datatype": "String",
    "mappingkey": "sampleName",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
},
{
    "display": "true",
    "ui_columnname": "Run Date",
    "db_columnname": "startDtTm",
    "datatype": "String",
    "mappingkey": "startDtTm",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
},
{
    "display": "true",
    "ui_columnname": "Status",
    "db_columnname": "process_Remark",
    "datatype": "String",
    "mappingkey": "process_Remark",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
}]